import ReactLoading from "react-loading";

export default function LoaderComponent() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col justify-center items-center bg-white bg-opacity-50 backdrop-blur-sm dark:bg-black dark:bg-opacity-50">
      <ReactLoading type="spinningBubbles" color="#fdb419" height={100} width={50} />
    </div>
  );
}
